/** @jsx jsx */
import * as React from "react"
import { jsx } from "@emotion/core";
import {FileUploaderStyles} from "../../styles/components/FileUploaderStyles";

interface HTMLInputEvent extends Event {
    target: HTMLInputElement & EventTarget;
}

interface IFileUploaderProps {
    accept: string,
    handleFileUpload: (file: Blob, mimeType: string, fileTitle: string, size: number) => Promise<boolean>,
    resetKey: boolean
}

const FileUploader = (props: IFileUploaderProps) => {
    const fileInput = React.useRef(null)
    const displayImageBlob = React.useRef<Blob>()
    const [loading, setLoading] = React.useState<boolean>(false)
    const [uploadStatus, setUploadStatus] = React.useState<boolean>(false)

    const handleFileChange = async (event: React.FormEvent<HTMLInputElement>) => {
        const file = (event.target as HTMLInputElement).files[0]
        if (file) {
            const Fr = new FileReader();
            Fr.onload = async (fileReadEvent) => {
                const imageData: ArrayBuffer = (fileReadEvent.currentTarget as any).result;
                displayImageBlob.current = new Blob([imageData], { type: file.type })
                // const displayImageDataUrl = URL.createObjectURL(displayImageBlob.current);
                // setFile({ displayImageDataUrl, displayImageMime: file.type });
                if (props.handleFileUpload) {
                    const fileUploadStatus: boolean = await props.handleFileUpload(displayImageBlob.current, file.type, file.name, file.size)
                    fileUploadStatus && setUploadStatus(true)
                }
                setLoading(false)
            }
            setLoading(true)
            Fr.readAsArrayBuffer(file);
        }
    }

    const resetState = () => {
        setUploadStatus(false)
        setLoading(false)
        if (fileInput.current && fileInput.current.value) {
            console.log({current: fileInput.current})
            fileInput.current.value = ""
        }
    }

    React.useEffect(() => {
        console.log("upload use effect")
        resetState()
    }, [props.resetKey])

    const getUploadIconUrl = () => {
        return loading
            ? "/images/loader/rolling-loader.gif"
            : uploadStatus
                ? "/images/pink-checkbox.png"
                : "/images/plus.svg"
    }

    return(
        <div css={FileUploaderStyles.container}>
            <div css={FileUploaderStyles.uploadContainer}>
                <div css={FileUploaderStyles.iconContainer}>
                    <img src={getUploadIconUrl()} css={FileUploaderStyles.img} />
                </div>
                <input
                    ref={fileInput}
                    css={FileUploaderStyles.input}
                    type="file"
                    onChange={handleFileChange}
                    accept={props.accept}
                />
            </div>
        </div>
    )
}

export default FileUploader